var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownLoadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.30957 13.5981L11.9612 16.2498L14.6129 13.5981",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9609 10V16.25",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58559 16.25H5.71059C5.09015 16.2494 4.47693 16.1168 3.91164 15.8611C3.34635 15.6054 2.84192 15.2324 2.43182 14.7668C2.02173 14.3012 1.71535 13.7537 1.53302 13.1607C1.35069 12.5676 1.29659 11.9426 1.3743 11.327C1.45201 10.7115 1.65975 10.1195 1.98375 9.59037C2.30774 9.06124 2.74057 8.60708 3.25351 8.25803C3.76645 7.90898 4.34777 7.67301 4.95888 7.56581C5.56998 7.4586 6.19691 7.4826 6.79803 7.63621",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33594 9.99988C6.33603 9.00959 6.57144 8.03351 7.02277 7.15205C7.47409 6.27058 8.12841 5.50899 8.93181 4.93C9.7352 4.35102 10.6647 3.97123 11.6436 3.82193C12.6226 3.67263 13.623 3.75809 14.5625 4.07127C15.502 4.38444 16.3536 4.91638 17.0471 5.62323C17.7407 6.33008 18.2563 7.19163 18.5516 8.13686C18.8469 9.0821 18.9134 10.084 18.7455 11.0599C18.5776 12.0359 18.1803 12.958 17.5861 13.7502",
    stroke: "#333333",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownLoadIcon);
export default __webpack_public_path__ + "static/media/DownLoadIcon.94531d90fce076a1d8fb80ba62838996.svg";
export { ForwardRef as ReactComponent };